// src/features/auth/hooks/useAuth.ts
import { useEffect } from 'react';
import useAuthStore from '../../../store/authStore';
import authService from '../../../services/authService';
import { fetchUserProfile } from '../../account/api/accountApi';
import { shouldBypassAuth, DEV_MOCK_USER } from '../../../config/devMode';

export const useAuth = () => {
  const { user, isLoading, error, setUser } = useAuthStore();
  const devBypass = shouldBypassAuth();

  // Check authentication status on mount
  useEffect(() => {
    const checkAuthStatus = async () => {
      // In dev bypass mode, set the mock user if not already set
      if (devBypass && !user) {
        setUser(DEV_MOCK_USER);
        return;
      }

      if (authService.isAuthenticated() && !user) {
        try {
          // Try to fetch user profile
          await fetchUserProfile();
        } catch (error) {
          // If error, clear tokens as they might be expired
          authService.logout();
        }
      }
    };

    checkAuthStatus();
  }, [user, devBypass, setUser]);

  // In dev bypass mode, always return authenticated with mock user
  if (devBypass) {
    return {
      isAuthenticated: true,
      user: user || DEV_MOCK_USER,
      isLoading: false,
      error: null,
    };
  }

  return {
    isAuthenticated: !!user,
    user,
    isLoading,
    error,
  };
};

export default useAuth;